(function () {
  'use strict';

  var searchModal = document.getElementById('SearchModal');
  var searchInput = searchModal ? searchModal.querySelector('input[type="text"]') : null;
  var resultsContainer = document.getElementById('PredictiveResults');
  var debounceTimer = null;

  if (!searchInput || !resultsContainer) return;

  searchInput.addEventListener('input', function () {
    var query = searchInput.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(function () {
      fetchPredictiveResults(query);
    }, 250);
  });

  function fetchPredictiveResults(query) {
    var url = window.routes.predictive_search_url +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,page,article' +
      '&resources[limit]=4' +
      '&section_id=predictive-search';

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var results = doc.querySelector('#predictive-search-results');

        if (results) {
          resultsContainer.innerHTML = results.innerHTML;
        } else {
          renderFallbackResults(query, html);
        }
      })
      .catch(function () {
        resultsContainer.innerHTML = '<p style="opacity:0.6;padding:20px;">Unable to load results. Press Enter to search.</p>';
      });
  }

  function renderFallbackResults(query, html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');

    var products = doc.querySelectorAll('[data-predictive-search-product]');
    var collections = doc.querySelectorAll('[data-predictive-search-collection]');

    var out = '';

    if (products.length > 0) {
      out += '<div class="predictive-result"><p class="predictive-result__title">Products</p>';
      products.forEach(function (p) {
        out += p.outerHTML;
      });
      out += '</div>';
    }

    if (collections.length > 0) {
      out += '<div class="predictive-result"><p class="predictive-result__title">Collections</p>';
      collections.forEach(function (c) {
        out += c.outerHTML;
      });
      out += '</div>';
    }

    if (out === '') {
      out = '<p style="opacity:0.6;padding:20px;">No results for "' + query + '". Press Enter for full search.</p>';
    }

    resultsContainer.innerHTML = out;
  }
})();
